import {Component, Input, Output, EventEmitter, SimpleChanges, ViewChild, OnChanges, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {Observable} from "rxjs";
import {MicroSelectComponent} from "../shared/select/micro-select.component";

@Component({
  selector: 'micro-sqlServerGroup-select',
  templateUrl: './sqlServerGroup-select.component.html'
})
export class SqlServerGroupSelectComponent implements OnInit, OnChanges  {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Output()
  sqlServerGroupIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  sqlServerGroupId:any;

  @Input()
  placeholder:any = 'Database Group';

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  options:any[];

  change(e) {
    this.sqlServerGroupIdChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
    }
  }

  reload() {
    let params:HttpParams = new HttpParams()
    ;
    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/sql/groups/all`, {params:params})
      .subscribe(data => {
        this.options = data as any[]
        this.sel.loading = false;
      });
  }

  ngOnInit(): void {
    this.reload();
  }
}
